<ng-container *ngIf="isMegaEnabled">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="!hasListSettledAndCommittedAccessFlag">
    <div class="banner row">
      <img src="assets/images/dashboard_banner.png" (load)="imageLoad()" />
      <div class="absolute-container-mega-access" *ngIf="imageLoaded">
        <div class="content-mega-access">
          <h1>Welcome to Structured Transactions Portal.</h1>
          <p>A self-service web-based portal for all your Structured products needs.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="header__bg" *ngIf="hasListSettledAndCommittedAccessFlag">
    <div class="dashboard-parent-container">
      <ng-container *ngIf="LDShowDynamicBanner">
        <section
          class="committed-megas-top-section-dynamic-banner"
          (mouseleave)="startScroll()"
          (mouseenter)="stopScroll()"
          *ngIf="dynamicBannerCount && shouldDisplayBanner()"
        >
          <div class="row">
            <div class="flipping-text-header">
              <span class="marquee-inner" [innerHTML]="dynamicBannerHeader"></span>
            </div>
            <div class="flipping-text">
              <span class="marquee-inner" [innerHTML]="dynamicBannerText"></span>
            </div>
          </div>
        </section>
      </ng-container>
      <header class="header">
        <section
          class="committed-megas-top-section"
          routerLink="mega-trade/committed-mega"
          *ngIf="committedMegasForCollateralCount > 0"
        >
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
              <div class="you-have-comitted">
                You have
                <span class="committed-megas-for-collateral">{{
                  committedMegasForCollateralCount
                }}</span>
                <span *ngIf="committedMegasForCollateralCount > 1">committed pools that are </span>
                <span *ngIf="committedMegasForCollateralCount === 1">committed pool that is </span
                >due for pool information in the next 2 business days.
                <span class="click-here-to-upload"
                  >Click here to upload your pool information now.</span
                >
              </div>
            </div>
          </div>
        </section>

        <div class="row" *ngIf="hasCreateOrEditMegaAccessFlag">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4">
            <section class="mega_container create-megas-section">
              <div class="mega_content">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <h2 class="dashboard-create-megas-label">Create Megas/Supers</h2>
                    <span class="horizontal-line"></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <p>
                      You can now create Megas and Supers and calculate their costs in real time.
                      Create them one at a time or in bulk using our simple step by step process.
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <p id="get-started-now">Get Started Now!</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <button
                      [hidden]="!hasCreateOrEditMegaAccessFlag"
                      type="button"
                      class="button fm-primary-button single-pool-button"
                      routerLink="mega-trade/enter-details"
                    >
                      CREATE SINGLE POOL
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 bulk-create-mega-button">
                    <button
                      [hidden]="!hasCreateOrEditMegaAccessFlag"
                      type="button"
                      class="button fm-primary-button bulk-create-mega-button-width"
                      routerLink="bulk-upload/enter-mega-details"
                    >
                      CREATE MULTIPLE POOLS
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
            <section class="volume-by-month-section">
              <div class="volume-by-month-content">
                <div class="row">
                  <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                    <h2 class="volume-by-month-rows volume-by-month-label">Volume By Month</h2>
                  </div>
                  <div class="col-6 col-sm-6 col-md-6 col-lg-6 volume-by-month-left-padding">
                    <div class="row">
                      <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                        <span
                          ><i
                            class="fa fa-angle-left float-end year-month-left-right"
                            [ngClass]="{ disabled: isLeftArrowClicked }"
                            (click)="getMonthlyVolumeSummaryByIndex('-1')"
                          ></i
                        ></span>
                      </div>
                      <ng-container *ngIf="isVolumeSummaryForPreviousMonth">
                        <div
                          class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align calendar-month-year"
                        >
                          <div class="row">
                            <span class="volume-by-month-font-size-weight-bold">{{
                              currentMonthYear | date: 'MMM'
                            }}</span
                            ><br />
                          </div>
                          <div class="row">
                            <span class="volume-by-month-total">{{
                              currentMonthYear | date: 'yyyy'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="isVolumeSummaryForCurrentMonth">
                        <div
                          class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align calendar-month-year"
                        >
                          <div class="row">
                            <span class="volume-by-month-font-size-weight-bold">{{
                              currentMonthYear | date: 'MMM'
                            }}</span
                            ><br />
                          </div>
                          <div class="row">
                            <span class="volume-by-month-total">{{
                              currentMonthYear | date: 'yyyy'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="isVolumeSummaryForNextMonth">
                        <div
                          class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align calendar-month-year"
                        >
                          <div class="row">
                            <span class="volume-by-month-font-size-weight-bold">{{
                              currentMonthYear | date: 'MMM'
                            }}</span
                            ><br />
                          </div>
                          <div class="row">
                            <span class="volume-by-month-total">{{
                              currentMonthYear | date: 'yyyy'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                        <span
                          ><i
                            class="fa fa-angle-right float-start year-month-left-right"
                            [ngClass]="{ disabled: isRightArrowClicked }"
                            (click)="getMonthlyVolumeSummaryByIndex('1')"
                          ></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="volume-by-month-horizontal-line" />
                <div class="volume-by-month-rows">
                  <ng-container>
                    <div class="row">
                      <div
                        class="col-12 col-sm-12 col-md-12 col-lg-12"
                        *ngIf="currentMonthOffset === -1 && isErrorMessageExits"
                      >
                        <p class="no-committed-megas">{{ errorMessagePrevMonth }}</p>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="currentMonthOffset === 0 && isErrorMessageExits">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                      <p class="next-month-no-committed-megas">{{ firstErrorMsgForNextMonth }}</p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="currentMonthOffset === 1 && isErrorMessageExits">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                      <p class="next-month-no-committed-megas">{{ firstErrorMsgForNextMonth }}</p>
                    </div>
                  </ng-container>
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                      <ng-template #sfFIXElseBlock>
                        <ng-container *ngIf="!isErrorMessageExits">
                          <p class="volume-by-month-font-size-weight-bold">Single Family Fixed</p>
                          <p class="no-committed-megas-megatype">
                            You have not created any pools of this type for this month.
                          </p>
                        </ng-container>
                      </ng-template>
                      <ng-container
                        *ngIf="
                          showSFFixedMega && singleFamilyFixedMega === 'SFFIXMEGA';
                          else sfFIXElseBlock
                        "
                      >
                        <p class="volume-by-month-font-size-weight-bold">Single Family Fixed</p>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Committed</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.sfFIXCommitted
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Settled</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.sfFIXSettled
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                            <span class="mega-total">Total</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                            <span class="float-end">{{
                              committedSettledObject.sfFIXTotal
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                      <ng-template #mfFIXElseBlock>
                        <ng-container *ngIf="!isErrorMessageExits">
                          <p class="volume-by-month-font-size-weight-bold">Multi Family Fixed</p>
                          <p class="no-committed-megas-megatype">
                            You have not created any pools of this type for this month.
                          </p>
                        </ng-container>
                      </ng-template>
                      <ng-container
                        *ngIf="
                          showMFFixedMega && multiFamilyFixedMega === 'MFFIXMEGA';
                          else mfFIXElseBlock
                        "
                      >
                        <p class="volume-by-month-font-size-weight-bold">Multi Family Fixed</p>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Committed</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.mfFIXCommitted
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Settled</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.mfFIXSettled
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                            <span class="mega-total">Total</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                            <span class="float-end">{{
                              committedSettledObject.mfFIXTotal
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <hr *ngIf="!isErrorMessageExits" class="white-horizontal-line" />
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                      <ng-template #sfARMElseBlock>
                        <ng-container *ngIf="!isErrorMessageExits">
                          <p class="volume-by-month-font-size-weight-bold">Single Family ARM</p>
                          <p class="no-committed-megas-megatype">
                            You have not created any pools of this type for this month.
                          </p>
                        </ng-container>
                      </ng-template>
                      <ng-container
                        *ngIf="
                          showSFARMMega && singleFamilyARMMega === 'SFARMMEGA';
                          else sfARMElseBlock
                        "
                      >
                        <p class="volume-by-month-font-size-weight-bold">Single Family ARM</p>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Committed</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.sfARMCommitted
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Settled</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.sfARMSettled
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                            <span class="mega-total">Total</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                            <span class="float-end">{{
                              committedSettledObject.sfARMTotal
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                      <ng-template #mfARMElseBlock>
                        <ng-container *ngIf="!isErrorMessageExits">
                          <p class="volume-by-month-font-size-weight-bold">Multi Family ARM</p>
                          <p class="no-committed-megas-megatype">
                            You have not created any pools of this type for this month.
                          </p>
                        </ng-container>
                      </ng-template>
                      <ng-container
                        *ngIf="
                          showMFARMMega && multiFamilyARMMega === 'MFARMMEGA';
                          else mfARMElseBlock
                        "
                      >
                        <p class="volume-by-month-font-size-weight-bold">Multi Family ARM</p>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Committed</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.mfARMCommitted
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                            <span class="mega-total">Settled</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="float-end">{{
                              committedSettledObject.mfARMSettled
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                            <span class="mega-total">Total</span>
                          </div>
                          <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                            <span class="float-end">{{
                              committedSettledObject.mfARMTotal
                                | currency: 'USD' : 'symbol-narrow' : '1.0'
                            }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <invd-fm-loading-page
                [isRunning]="fmLoadingPageService.isLoaderRequesting()"
              ></invd-fm-loading-page>
            </section>
          </div>
        </div>

        <!--collateral user only sees volume of month section-->
        <div class="row" *ngIf="!hasCreateOrEditMegaAccessFlag">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <div class="volume-by-month-section-collateral-user">
              <section class="volume-by-month-section">
                <div class="volume-by-month-content">
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                      <h2 class="volume-by-month-rows volume-by-month-label">Volume By Month</h2>
                    </div>
                    <div
                      class="col-6 col-sm-6 col-md-6 col-lg-6 volume-by-month-left-padding-collateral"
                    >
                      <div class="row">
                        <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                          <span
                            ><i
                              class="fa fa-angle-left float-end year-month-left-right"
                              [ngClass]="{ disabled: isLeftArrowClicked }"
                              (click)="getMonthlyVolumeSummaryByIndex('-1')"
                            ></i
                          ></span>
                        </div>
                        <ng-container *ngIf="isVolumeSummaryForPreviousMonth">
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                            <div class="row">
                              <span class="volume-by-month-font-size-weight-bold">{{
                                currentMonthYear | date: 'MMM'
                              }}</span
                              ><br />
                            </div>
                            <div class="row">
                              <span class="volume-by-month-total">{{
                                currentMonthYear | date: 'yyyy'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="isVolumeSummaryForCurrentMonth">
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                            <div class="row">
                              <span class="volume-by-month-font-size-weight-bold">{{
                                currentMonthYear | date: 'MMM'
                              }}</span
                              ><br />
                            </div>
                            <div class="row">
                              <span class="volume-by-month-total">{{
                                currentMonthYear | date: 'yyyy'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="isVolumeSummaryForNextMonth">
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                            <div class="row">
                              <span class="volume-by-month-font-size-weight-bold">{{
                                currentMonthYear | date: 'MMM'
                              }}</span
                              ><br />
                            </div>
                            <div class="row">
                              <span class="volume-by-month-total">{{
                                currentMonthYear | date: 'yyyy'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                        <div class="col-4 col-sm-4 col-md-4 col-lg-4 volume-by-month-text-align">
                          <span
                            ><i
                              class="fa fa-angle-right float-start year-month-left-right"
                              [ngClass]="{ disabled: isRightArrowClicked }"
                              (click)="getMonthlyVolumeSummaryByIndex('1')"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="volume-by-month-horizontal-line" />
                  <div class="volume-by-month-rows">
                    <ng-container>
                      <div class="row">
                        <div
                          class="col-12 col-sm-12 col-md-12 col-lg-12"
                          *ngIf="currentMonthOffset === -1 && isErrorMessageExits"
                        >
                          <p class="no-committed-megas">{{ errorMessagePrevMonth }}</p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="currentMonthOffset === 0 && isErrorMessageExits">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <p class="no-committed-megas">{{ firstErrorMsgForNextMonth }}</p>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="currentMonthOffset === 1 && isErrorMessageExits">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <p class="no-committed-megas">{{ firstErrorMsgForNextMonth }}</p>
                      </div>
                    </ng-container>
                    <div class="row">
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <ng-template #sfFIXElseBlock>
                          <ng-container *ngIf="!isErrorMessageExits">
                            <p class="volume-by-month-font-size-weight-bold">Single Family Fixed</p>
                            <p class="no-committed-megas-megatype">
                              You have not created any pools of this type for this month.
                            </p>
                          </ng-container>
                        </ng-template>
                        <ng-container
                          *ngIf="
                            showSFFixedMega && singleFamilyFixedMega === 'SFFIXMEGA';
                            else sfFIXElseBlock
                          "
                        >
                          <p class="volume-by-month-font-size-weight-bold">Single Family Fixed</p>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Committed</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.sfFIXCommitted
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Settled</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.sfFIXSettled
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                              <span class="mega-total">Total</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                              <span class="float-end">{{
                                committedSettledObject.sfFIXTotal
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <ng-template #mfFIXElseBlock>
                          <ng-container *ngIf="!isErrorMessageExits">
                            <p class="volume-by-month-font-size-weight-bold">Multi Family Fixed</p>
                            <p class="no-committed-megas-megatype">
                              You have not created any pools of this type for this month.
                            </p>
                          </ng-container>
                        </ng-template>
                        <ng-container
                          *ngIf="
                            showMFFixedMega && multiFamilyFixedMega === 'MFFIXMEGA';
                            else mfFIXElseBlock
                          "
                        >
                          <p class="volume-by-month-font-size-weight-bold">Multi Family Fixed</p>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Committed</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.mfFIXCommitted
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Settled</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.mfFIXSettled
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                              <span class="mega-total">Total</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                              <span class="float-end">{{
                                committedSettledObject.mfFIXTotal
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <hr *ngIf="!isErrorMessageExits" class="white-horizontal-line" />
                    <div class="row">
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <ng-template #sfARMElseBlock>
                          <ng-container *ngIf="!isErrorMessageExits">
                            <p class="volume-by-month-font-size-weight-bold">Single Family ARM</p>
                            <p class="no-committed-megas-megatype">
                              You have not created any pools of this type for this month.
                            </p>
                          </ng-container>
                        </ng-template>
                        <ng-container
                          *ngIf="
                            showSFARMMega && singleFamilyARMMega === 'SFARMMEGA';
                            else sfARMElseBlock
                          "
                        >
                          <p class="volume-by-month-font-size-weight-bold">Single Family ARM</p>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Committed</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.sfARMCommitted
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Settled</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.sfARMSettled
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                              <span class="mega-total">Total</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                              <span class="float-end">{{
                                committedSettledObject.sfARMTotal
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <ng-template #mfARMElseBlock>
                          <ng-container *ngIf="!isErrorMessageExits">
                            <p class="volume-by-month-font-size-weight-bold">Multi Family ARM</p>
                            <p class="no-committed-megas-megatype">
                              You have not created any pools of this type for this month.
                            </p>
                          </ng-container>
                        </ng-template>
                        <ng-container
                          *ngIf="
                            showMFARMMega && multiFamilyARMMega === 'MFARMMEGA';
                            else mfARMElseBlock
                          "
                        >
                          <p class="volume-by-month-font-size-weight-bold">Multi Family ARM</p>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Committed</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.mfARMCommitted
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                              <span class="mega-total">Settled</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                              <span class="float-end">{{
                                committedSettledObject.mfARMSettled
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 total-label">
                              <span class="mega-total">Total</span>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 volume-total-orange">
                              <span class="float-end">{{
                                committedSettledObject.mfARMTotal
                                  | currency: 'USD' : 'symbol-narrow' : '1.0'
                              }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <invd-fm-loading-page
                  [isRunning]="fmLoadingPageService.isLoaderRequesting()"
                ></invd-fm-loading-page>
              </section>
            </div>
          </div>
        </div>
        <!--Upcoming Mega Settlements-->
        <section class="upcoming-mega">
          <div class="row">
            <div class="col-9 col-sm-9 col-md-9 col-lg-9">
              <span class="upcoming-mega-header">Upcoming Settlements</span>&nbsp;&nbsp;
            </div>
            <div
              class="col-3 col-sm-3 col-md-3 col-lg-3"
              *ngIf="upcomingSettlementsMegaList !== null"
            >
              <div class="row float-end">
                <span class="status">Status</span>
                <div
                  class="dropdown status-dropdown"
                  id="timeSpan"
                  (mouseleave)="closeStatusDropdown()"
                >
                  <button
                    class="btn btn-secondary dropdown-toggle time-span-dropdown dropdown-text"
                    type="button"
                    id="dropdownTimeSpan"
                    (click)="toggleStatusDropdown()"
                    [attr.aria-expanded]="isStatusDropdownOpen"
                  >
                    {{ selectedStatus ? selectedStatus : 'ALL' }}
                    <span class="fa fa-chevron-down mega-dropdown-caret"></span>
                  </button>
                  <ul
                    class="dropdown-menu dropdown-select-time"
                    [ngClass]="{ show: isStatusDropdownOpen }"
                  >
                    <li>
                      <button type="button" class="dropdown-item" (click)="setSelected('ALL')">
                        ALL
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="setSelected('ALLOCATED')"
                      >
                        ALLOCATED
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="setSelected('ALLOCATION_PENDING')"
                      >
                        ALLOCATION PENDING
                      </button>
                    </li>
                    <li>
                      <button type="button" class="dropdown-item" (click)="setSelected('DUE')">
                        DUE
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="setSelected('IN REVIEW')"
                      >
                        IN REVIEW
                      </button>
                    </li>
                    <li>
                      <button type="button" class="dropdown-item" (click)="setSelected('OVERDUE')">
                        OVERDUE
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row download-template">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <a class="view-committed-megas" href="#/mega-trade/committed-mega"
                >View Committed Pools Listing</a
              >
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <span class="float-end download-template-pos">
                <i
                  class="fa fa-download download-template-icon"
                  (click)="downloadPoolInfoTemplate()"
                ></i>
                <a class="download-pool-info-template" (click)="downloadPoolInfoTemplate()"
                  >Download Pool Information Template (.xlsx)</a
                >
              </span>
            </div>
          </div>
          <ng-container *ngIf="upcomingSettlementsMegaList === null">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <p class="no-upcoming-settlement-megas">{{ upcomingSettlementErrMsg }}</p>
              </div>
            </div>
          </ng-container>

          <div class="row" *ngIf="upcomingSettlementsMegaList !== null">
            <ng-container *ngIf="upcomingSettlementsMegaListCount === 0">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <p class="no-upcoming-settlement-megas">
                  There are no Pools with {{ statusUpcomingMegaSettlement }} status that are going
                  to settle in next 2 weeks. Please check back as new Pools may be added.
                </p>
              </div>
            </ng-container>

            <div
              class="fm-cdx-table"
              [ngClass]="{ 'table-height': upcomingSettlementsMegaListCount > 4 }"
            >
              <table class="fm-cdx-table__static" *ngIf="upcomingSettlementsMegaListCount > 0">
                <thead>
                  <tr class="th_row">
                    <th class="th_column">
                      <span>settlement</span>
                    </th>
                    <th class="th_column">
                      <span>POOL #</span>
                    </th>
                    <th class="th_column">cusip</th>
                    <th class="th_column th_column--is-numeric">
                      <span>deal amount</span>
                    </th>
                    <th class="th_column th_column--is-numeric">
                      <span>fee</span>
                    </th>
                    <th class="th_column">COLLATERAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="td_row commit-mega-table-header"
                    *ngFor="
                      let upcomingMega of upcomingSettlementsMegaList
                        | filter: 'status' : selectedStatus;
                      trackBy: trackByIdentity
                    "
                  >
                    <td class="td_cell" id="SFFIXMEGA-commit-mega-settlementDate">
                      <span
                        [ngClass]="{
                          'overdue-red':
                            upcomingMega?.status === 'OVERDUE' ||
                            upcomingMega?.status === 'DUEWARNING',
                        }"
                        >{{ upcomingMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}</span
                      ><br />
                    </td>
                    <td class="td_cell commit-mega-pool-number" id="SFFIXMega-pool-number">
                      <span>{{ upcomingMega ? upcomingMega.poolNumber : '' }}</span
                      ><br />
                    </td>
                    <td class="td_cell" id="SFFIXMega-commit-mega-prefix">
                      <span> {{ upcomingMega?.cusip }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric" id="SFFIXMega-commit-mega-coupon">
                      <span>{{
                        upcomingMega?.tradeAmount | currency: 'USD' : 'symbol-narrow' : '1.0'
                      }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric" id="SFFIXMega-deal-amount-fee">
                      <ng-container *ngIf="upcomingMega.feeDollars != null">
                        <ng-container *ngIf="needsDisclaimer(upcomingMega); else noDisclaimer">
                          <span class="fee-warning-red">
                            {{
                              upcomingMega?.feeDollars
                                | currency: 'USD' : 'symbol-narrow' : '1.2-2'
                            }}*
                          </span>
                        </ng-container>
                        <ng-template #noDisclaimer>
                          {{
                            upcomingMega?.feeDollars | currency: 'USD' : 'symbol-narrow' : '1.2-2'
                          }}
                        </ng-template>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega.feeTicks != null">
                        <ng-container *ngIf="needsDisclaimer(upcomingMega); else noTickDisclaimer">
                          <span class="fee-warning-red"> {{ upcomingMega?.feeTicks }}/32* </span>
                        </ng-container>
                        <ng-template #noTickDisclaimer>
                          {{ upcomingMega?.feeTicks }}/32
                        </ng-template>
                      </ng-container>
                      <ng-container
                        *ngIf="upcomingMega.feeTicks === null && upcomingMega.feeDollars === null"
                      >
                        {{ 0 | currency: 'USD' : 'symbol-narrow' : '1.0' }}
                      </ng-container>
                    </td>
                    <td class="td_cell">
                      <ng-container *ngIf="upcomingMega?.status === 'ALLOCATED'">
                        <span class="allocated allocated-green"
                          >ALLOCATED <i class="fa fa-check-circle icon-disable allocated-green"></i
                        ></span>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega?.status === 'OVERDUE'">
                        <span class="overdue"
                          >OVERDUE
                          <i
                            class="fa fa-exclamation-circle tooltip-error icon-disable overdue-red"
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                          ></i
                        ></span>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          upcomingMega?.status === 'DUE' || upcomingMega?.status === 'DUEWARNING'
                        "
                      >
                        <div class="row">
                          <div class="col-lg-6">
                            <span class="allocated" *ngIf="upcomingMega?.status === 'DUE'"
                              >DUE</span
                            >
                            <span
                              class="allocated overdue-red"
                              *ngIf="upcomingMega?.status === 'DUEWARNING'"
                              >DUE</span
                            >
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega?.status === 'INREVIEW'">
                        <span class="in-review">IN REVIEW</span>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega?.status === 'ALLOCATION_PENDING'">
                        <span class="allocated allocation-pending">ALLOCATION PENDING</span>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega?.status === 'VALIDATING'">
                        <span class="in-review">VALIDATING</span>
                      </ng-container>
                      <ng-container *ngIf="upcomingMega?.status === 'FAILED'">
                        <span class="allocated overdue-red">FAILED</span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="fee-warning-red">{{ disclaimerMessage }}</p>
          </div>
          <invd-fm-loading-page
            [isRunning]="fmLoadingPageService.isLoaderRequesting()"
          ></invd-fm-loading-page>
        </section>
      </header>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isRCREnabled && !isMegaEnabled">
  <div class="container-fluid">
    <div class="banner row">
      <img src="assets/images/dashboard_banner.png" (load)="imageLoad()" />
      <div class="absolute-container-rcr" *ngIf="imageLoaded">
        <div class="content">
          <h3>Welcome to Investor Direct</h3>
          <span class="horizontal-line"></span>
          <p>
            A self-service web-based portal to complete your Recombinable REMICs (RCR) exchanges.
          </p>
        </div>
      </div>
    </div>

    <div class="row request-container" *ngIf="!isRCRSupportRoleUser">
      <div class="col-12 col-sm-12 col-md-4 request-mega">
        <div class="card-container">
          <h3 class="card-sub-heading">REQUEST AN EXCHANGE</h3>
          <p class="card-paragraph">
            Create and customize your request for an RCR as well as SMBS exchange
          </p>
          <div class="form-group request-mega-button-container">
            <button
              type="button"
              class="button fm-primary-button"
              href="#/rcr-exchange/lookup"
              (click)="navigateToLookup()"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-4 request-exchange">
        <div class="card-container">
          <h3 class="request-exchange-title">FEE SCHEDULES</h3>

          <ul class="list-group list-unstyled">
            <li class="request-info-item">
              <!--<a routerLink="/fee-schedules" class="dashboard&#45;&#45;links">-->
              <a (click)="getFeeSchedule()" class="dashboard--links">
                RCR Fee Schedules
                <span class="float-end request-info-right-arrow"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-4 request-exchange">
        <div class="card-container">
          <h3 class="request-exchange-title">INDUSTRY INFORMATION</h3>

          <ul class="list-group list-unstyled">
            <li class="request-info-item">
              <a
                href="http://fanniemae.com/portal/jsp/mbs/documents/remic/remicprospectussupplements.html"
                target="_blank"
                class="dashboard--links"
              >
                REMIC Prospectus Supplements
                <span class="float-end request-info-right-arrow"></span>
              </a>
            </li>

            <li class="request-info-item">
              <a
                href="http://fanniemae.com/portal/jsp/mbs/documents/remic/trustagreements/index.html"
                target="_blank"
                class="dashboard--links"
              >
                REMIC Trust Agreements
                <span class="float-end request-info-right-arrow"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div class="fee-shedule-model-window" *ngIf="showFeeSheduleModelWindow">
  <div class="panel panel-default fadeInUpBig">
    <button
      type="button"
      class="close float-end"
      aria-label="Close"
      (click)="closeFeeSheduleModelWindow()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <invd-fee-schedule></invd-fee-schedule>
      <div class="fee-schedule" (click)="closeFeeSheduleModelWindow()">GOT IT</div>
    </div>
  </div>
</div>

<!--<invd-fm-loading-page [isRunning]="fmLoadingPageService.isLoaderRequesting"></invd-fm-loading-page>-->
